// source: pbtypes/gen/vehicle_attributes/soc_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.vehicle_attributes.SocType', null, global);
/**
 * @enum {number}
 */
proto.vehicle_attributes.SocType = {
  UNKNOWN: 0,
  XAVIER: 1,
  QC865: 2,
  WORKSTATION: 3,
  ORIN: 4,
  QCS405: 5,
  QCS6490: 6,
  CQ8750S: 7
};

goog.object.extend(exports, proto.vehicle_attributes);
